import type { IStyle } from "@fluentui/react";

/**
 * Returns DPI-specific style selectors that adjust the given property to be an
 * integer number of pixels at the given DPI.
 *
 * @param property The name of the property to scale
 * @param getScaledValue Callback to get the scaled value that should multiply
 *                       the 100% DPI value by the given multiplier.
 */
export function scalePropertyWithDpi(
  property: string,
  getScaledValue: (multiplier: number) => number | string
): IStyle {
  return {
    selectors: {
      // 75% zoom level
      "@media (resolution: 72dpi)": {
        [property]: getScaledValue(1.33),
      },

      // 125% zoom level
      "@media (resolution: 120dpi)": {
        [property]: getScaledValue(0.8),
      },

      // 150% zoom level
      "@media (resolution: 144dpi)": {
        [property]: getScaledValue(0.67),
      },

      // 175% zoom level
      "@media (resolution: 168dpi)": {
        [property]: getScaledValue(1.14),
      },

      // 250% zoom level
      "@media (resolution: 240dpi)": {
        [property]: getScaledValue(0.8),
      },
    },
  };
}

export function scaleBorderWithDpi(borderWidthAt100: number) {
  return scalePropertyWithDpi(
    "borderWidth",
    (multiplier) => borderWidthAt100 * multiplier
  );
}
